import storeWithFlags from '../../../utils/storeWithFlags'

export default storeWithFlags
	.create({})